module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_traffic.ae6aa1da.svg";